import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../../api";
import { BASE_URL } from "../../../api";
import { updateProgress } from "./slice";

// Send promo emails with real-time SSE progress
export const sendPromoEmails = createAsyncThunk(
  "promoEmails/sendPromoEmails",
  async (emailData, { rejectWithValue, dispatch }) => {
    try {
      const response = await fetch(`${BASE_URL}/api/emails/send-promo-emails`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify(emailData),
      });

      if (!response.ok) {
        const errorData = await response.json();
        return rejectWithValue(
          errorData.message || "Greška pri slanju email-ova",
        );
      }

      const reader = response.body.getReader();
      const decoder = new TextDecoder();
      let finalResults = null;

      while (true) {
        const { done, value } = await reader.read();
        if (done) break;

        const text = decoder.decode(value, { stream: true });
        // Parse SSE data lines
        const lines = text.split("\n");
        for (const line of lines) {
          if (line.startsWith("data: ")) {
            try {
              const data = JSON.parse(line.slice(6));

              if (data.done) {
                // Final results
                finalResults = data;
              } else {
                // Progress update - dispatch to Redux
                dispatch(updateProgress(data));
              }
            } catch {
              // Skip malformed JSON
            }
          }
        }
      }

      if (finalResults?.error) {
        return rejectWithValue(finalResults.error);
      }

      return finalResults || { total: 0, sent: 0, failed: 0, errors: [] };
    } catch (error) {
      return rejectWithValue(
        error.message || "Greška pri slanju email-ova",
      );
    }
  },
);

// Send test email
export const sendTestEmail = createAsyncThunk(
  "promoEmails/sendTestEmail",
  async (testEmailData, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        "/emails/send-test-email",
        testEmailData,
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Greška pri slanju test email-a",
      );
    }
  },
);

// Clear results action
export const clearResults = createAsyncThunk(
  "promoEmails/clearResults",
  async (_, { dispatch }) => {
    dispatch({ type: "promoEmails/clearResults" });
  },
);
